<template>
  <div
    v-if="
      sessionTimeoutStore.minutesRemaining <=
      sessionTimeoutStore.sessionWarningMinutes
      && !hideModal
    "
    id="SessionExpiringPopup"
    class="timeout-modal__wrapper"
  >
    <div class="timeout-modal__inner">
      <div class="timeout-modal__flex">
        <i
          class="fa fa-exclamation-triangle fa-2x"
          style="margin-right: 10px"
        ></i>
        <div>Your session will expire shortly. Re-login to extend your session.<br /></div>
      </div>
      <div
        class="timeout-modal__btns"
      >
        <button
          type="button"
          @click="hideModal = true"
          class="btn btn-primary"
          style="margin-right: 10px"
        >
          Continue
        </button>
        <a class="btn btn-black" href="#" @click="logout()"
          >Re-login</a
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSessionTimeoutStore } from "@/stores/useSessionTimeoutStore";
import { onBeforeMount, ref } from "vue";
import CognitoAuth from "@/shared/access/CognitoAuth";
import { CookieTypes } from "@/Models/CookieTypes";
import { deleteCookie } from "@/shared/helpers/cookieHelper";
import { SessionCacheService } from "@/shared/services/SessionCacheService";
import { CacheService } from "@/shared/services/CacheService";
import { ENV_KEYS, getEnvValue } from "@/shared/helpers/envHelper";

const sessionTimeoutStore = useSessionTimeoutStore();
const hideModal = ref(false);

const refreshTokenLifetimeMinutes =
  getEnvValue(ENV_KEYS.CognitoRefreshTokenLifetimeMinutes) ?? 1 * 24 * 60; // Default to 1 day if not set

const setUserLoginTimeAsync = async function () {
  sessionTimeoutStore.LoginTime = await CognitoAuth.getLoginTime() || 0;
};

function ExtendSession() {
  // This will wake up the session. It will also organically update the property sessionTimeoutStore.minutesRemaining
  sessionTimerHandler(true);
  console.debug(
    "Session Extended. minutesRemainingInSession: " +
      sessionTimeoutStore.minutesRemaining
  );
  return true;
}

const updateMinutesRemaining = function () {
  const refreshTokenExpiration =
    sessionTimeoutStore.LoginTime +
    refreshTokenLifetimeMinutes * 60;
  sessionTimeoutStore.minutesRemaining = (refreshTokenExpiration - new Date().getTime() / 1000) / 60;
};

let lastUpdate = new Date();

async function sessionTimerHandler(extendSession: boolean = false) {
  // if the last update was less than a minute ago, don't do any updates yet
  if (!extendSession && lastUpdate.getTime() > new Date().getTime() - 60000)
    return;
  lastUpdate = new Date();
  updateMinutesRemaining();

  if (sessionTimeoutStore.minutesRemaining <= 1) {
    //instead of just popping up session expired, log the user out. it's a cleaner UX
    console.debug("Session has expired.");
    logout();
    return;
  }

  // const now = new Date().getTime();
  // const oneHourAgo = now - 60 * 60 * 1000;

  // // if the user has been active in the last hour and the session is about to expire, renew the token
  // if (
  //   sessionTimeoutStore.minutesRemaining <= 10 &&
  //   sessionTimeoutStore.LastUserActivityTime.getTime() > oneHourAgo
  // ) {
  //   console.debug(
  //     "sessionTimerHandler() => Less than 10 minutes remaining. User activity detected within the last hour. Renewing token."
  //   );
  //   await CognitoAuth.refreshSession();
  //   await setUserLoginTimeAsync();
  // } else {
  //   console.debug(
  //     "sessionTimerHandler() => sessionTimeoutStore.minutesRemaining: " +
  //       sessionTimeoutStore.minutesRemaining
  //   );
  // }
}

function UpdateUserActivity() {
  sessionTimeoutStore.LastUserActivityTime = new Date();
}

function UpdateUserActivityOnFocus() {
  sessionTimeoutStore.LastUserActivityTime = new Date();
  sessionTimerHandler();
}

const logout = async function () {
  deleteCookie(CookieTypes.Authorization);
  SessionCacheService.clearSessionCache();
  CacheService.removeAllExpired();
  CognitoAuth.signOut();
};

onBeforeMount(async () => {
  await setUserLoginTimeAsync();
  updateMinutesRemaining();
  if (sessionTimeoutStore.minutesRemaining <= 0) {
    console.log("Token expiration is invalid. Logging out..."); // Clear user cache when session expires
    logout();
    return;
  }

  window.addEventListener("mousemove", UpdateUserActivity);
  window.addEventListener("keydown", UpdateUserActivity);
  window.addEventListener("scroll", UpdateUserActivity);
  window.onfocus = UpdateUserActivityOnFocus;

  // once per minute until window is closed.
  setInterval(sessionTimerHandler, 60000);
});
</script>
